export default "__VITE_ASSET__5b37fd3b__"